import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})

export class AuthService {
    headers: HttpHeaders | { [header: string]: string | string[]; };

    constructor(private http: HttpClient) {
        this.headers = new HttpHeaders();
        this.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

    clear(): void {
        localStorage.clear();
    }

    isAuthenticated(): boolean {
        return localStorage.getItem('token') != null && !this.isTokenExpired();
    }

    isTokenExpired(): boolean {
        return false;
    }

    logout() {
        return this.http.get<any>('Account/Logout', { headers: this.headers })
    }

    login(user) {
        const headers: HttpHeaders = new HttpHeaders();
        headers.set('Content-Type', 'application/json');
        headers.set('Access-Control-Allow-Headers', 'Content-Type');
        headers.set('Access-Control-Allow-Methods', 'GET,PUT,POST,OPTIONS,DELETE');
        headers.set('Access-Control-Allow-Origin', '*');

        return this.http.post<any>('Account/Login', user, { headers: headers })
    }

    getDMSToken(emailId: string) {
        return this.http.post<any>(`Account/AuthenticateDocMSUser?Email=${emailId}`, {});
    }

    getSessionDetails() {
        return this.http.get<any>('Account/GetSession');
    }

    getUserSessionDetails() {
        return this.http.get<any>('Account/GetUserSession');
    }

    getUserSession() {
        return this.http.get<any>('Account/UserSession');
    }
}
